import { createSelector } from 'reselect';

const getPlayFeed = (state) => {
    const { liveData } = state.gumbo;
    const storePlays = liveData?.plays || {};
    const { playsByInning } = storePlays;

    return playsByInning;
};

export const getPlayFeedState = createSelector(
    [getPlayFeed],
    (playsByInning = []) => ({
        playsByInning
    })
);
